import { z } from 'zod';

// API SCHEMAS (REST endpoints)
// Empty schema since all params come from URL
export const StartConnectionRequestSchema = z.object({});

export const StartConnectionResponseSchema = z.object({
  paragonUserId: z.string(),
  signedToken: z.string(),
  paragonProjectId: z.string(),
});

// TYPE EXPORTS
export type StartConnectionRequest = z.infer<
  typeof StartConnectionRequestSchema
>;
export type StartConnectionResponse = z.infer<
  typeof StartConnectionResponseSchema
>;
